import {
  commitMutation,
  graphql
} from 'react-relay';
import environment from '../Environment';

const mutation = graphql`
mutation UpdateCcnSettingsMutation($ccnId: String!, $settings: CcnSettingsInput!) {
  updateCcnSettings(ccnId: $ccnId, settings: $settings) { 
    ok
    error
  }
}
`;

export default (ccnId, settings, done) => {
  const variables = {
    ccnId,
    settings
  };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      updater: () => {
      },
      optimisticUpdater: () => {
      },
      onCompleted: (response) => {
        const { ok, error } = response.updateCcnSettings;
        done(ok, error);
      },
      onError: error => {
        done(false, error);
      }
    }
  );
};
